import { TenantValidationTypesConst } from '../types';

export const CONSTANTS = {
  API_BACKEND: process.env.REACT_APP_API_URL,
  WS_URL: process.env.REACT_APP_WS_URL,
  ENV: process.env.REACT_APP_ENV as
    | 'development'
    | 'staging'
    | 'production'
    | undefined,
  DISABLE_IN_PRO: process.env.REACT_APP_ENV === 'production',
  IS_PRODUCTION: process.env.REACT_APP_ENV === 'production',
  IS_DEVELOPMENT: process.env.REACT_APP_ENV === 'development',
  IS_STAGING: process.env.REACT_APP_ENV === 'staging',
  storeAccessTokenKey: '@smartpay_accessToken',
  storeRefreshTokenKey: '@smartpay_refreshToken',
  storeUserKey: '@smartpay_user',
  EMPLOYEEES_PAGINATE_LIMIT: 20,
  SALARIES_PAGINATE_LIMIT: 28,
  MATRIX_POSITIONS_PAGINATE_LIMIT: 20,
  APP_ENV: process.env.REACT_APP_ENV,
  BUGSNAG_API_KEY: process.env.REACT_APP_BUGSNAG_API_KEY,
  ENABLE_FEATURE_TENANTS: process.env.REACT_APP_ENABLE_FEATURE_TENANTS || '',
};

export const MONTHS = {
  PT: [
    {
      key: 'month-1',
      month_number: 1,
      month_number_original: 0,
      name: 'janeiro',
    },
    {
      key: 'month-2',
      month_number: 2,
      month_number_original: 1,
      name: 'fevereiro',
    },
    {
      key: 'month-3',
      month_number: 3,
      month_number_original: 2,
      name: 'março',
    },
    {
      key: 'month-4',
      month_number: 4,
      month_number_original: 3,
      name: 'abril',
    },
    {
      key: 'month-5',
      month_number: 5,
      month_number_original: 4,
      name: 'maio',
    },
    {
      key: 'month-6',
      month_number: 6,
      month_number_original: 5,
      name: 'junho',
    },
    {
      key: 'month-7',
      month_number: 7,
      month_number_original: 6,
      name: 'julho',
    },
    {
      key: 'month-8',
      month_number: 8,
      month_number_original: 7,
      name: 'agosto',
    },
    {
      key: 'month-9',
      month_number: 9,
      month_number_original: 8,
      name: 'setembro',
    },
    {
      key: 'month-10',
      month_number: 10,
      month_number_original: 9,
      name: 'outubro',
    },
    {
      key: 'month-11',
      month_number: 11,
      month_number_original: 10,
      name: 'novembro',
    },
    {
      key: 'month-12',
      month_number: 12,
      month_number_original: 11,
      name: 'dezembro',
    },
  ],
};

export const ERRORS_MESSAGE = {
  apiRequestError:
    'Houve algum problema ao tentar listar os dados. Por favor, contacte o administrador do sistema!',
};

export const TENANT_VALIDATION_TYPES: TenantValidationTypesConst = {
  GRADE_GHANGE: 'grade-structure-change-validator',
};
TENANT_VALIDATION_TYPES['GRADE_GHANGE'];

const PERMISSIONS_NAMES = [
  'head-menu@editar-perfil',
  'head-menu@notificacoes',
  'head-menu@integracoes',
  'head-menu@meus-planos',

  'menu@home',
  'menu@seus-dados',
  'menu@estrutura-de-cargos',
  'menu@estrategia-de-remuneracao',
  'menu@dashboard-de-remuneracao',
  'menu@meritocracia',
  'menu@central-de-upload',
  'menu@controle-de-acesso',
  //** SUB-MENU SEUS DADOS **
  'sub-menu-seus-dados@dados-da-empresa',
  'sub-menu-seus-dados@politicas-de-meritocracia',
  'sub-menu-seus-dados@dados-dos-funcionarios',
  'sub-menu-seus-dados@grades',
  'sub-menu-seus-dados@tabela-salarial',
  //** SUB-MENU ESTRUTURA DE CARGOS **
  'sub-menu-estrutura-de-cargos@criacao-de-matriz',
  'sub-menu-estrutura-de-cargos@visualizar-matriz',
  'sub-menu-estrutura-de-cargos@de-para-cargo',
  'sub-menu-estrutura-de-cargos@descricao-de-cargo',
  //** SUB-MENU ESTRATEGIA DE REMUNERACAO **
  'sub-menu-estrategia-de-remuneracao@tabelas-salariais',
  'sub-menu-estrategia-de-remuneracao@custo-de-enquadramento',
  'sub-menu-estrategia-de-remuneracao@dados-de-mercado',
  'sub-menu-estrategia-de-remuneracao@analise-de-competitividade',
  'sub-menu-estrategia-de-remuneracao@alvos-de-incentivo',
  //** SUB-MENU MERITOCRACIA **
  'sub-menu-meritocracia@simulacoes',
  'sub-menu-meritocracia@parametrizacoes',
  //** SUB-MENU CENTRRAL DE UPLOAD **
  'sub-menu-central-de-upload@upload',
  'sub-menu-central-de-upload@historico',
  //** GRAFICOS**
  'grafico@custo-de-pessoal-resultado',
  'grafico@media-salarial-por-nivel',
  'grafico@folha-nominal-atual-mensal',
  'grafico@custo-da-folha-nominal-mensal',
  'grafico@massa-salarial-por-nivel',
  'grafico@orcamento-de-folha-nominal-anual',
  'grafico@posicionamento-na-faixa',
  'grafico@headcount-por-nivel',
  'grafico@headcount',
  'grafico@dispersao-tabela',
  'grafico@dispersao-mercado',
  //** RELATORIOS DIVERSIDADE**
  'relatorio-diversidade@classificacao',
  'relatorio-diversidade@genero-headcount',
  'relatorio-diversidade@cor-headcount',
  'relatorio-diversidade@media-salarial',
  'relatorio-diversidade@tempo-de-casa',
  'relatorio-diversidade@idade',
  'relatorio-diversidade@idade-admissao',
  //** RELATORIOS MOVIMENTACOES SALARIAIS**
  'relatorio-movimentacoes-salariais@saldo-de-desligamentos',

  //** PAGINAS**
  'page-perfil@editar-perfil',
  'page-perfil@integracoes',
  'page-perfil@meus-planos',
  'page-home@graficos',
  //** PAGE SEUS DADOS**
  'page-seus-dados@dados-da-empresa',
  'page-seus-dados@setor',
  'page-seus-dados@politicas-de-meritocracia',
  'page-seus-dados@dados-dos-funcionarios',
  'page-seus-dados@area-de-funcionario',
  'page-seus-dados@grades',
  'page-seus-dados@tabela-salarial',
  'page-seus-dados@tabela-salarial-exportar',
  //** PAGE ESTRUTURA DE CARGOS**
  'page-estruturas-de-cargos@matriz-construcao',
  'page-estruturas-de-cargos@matriz-de-cargos',
  'page-estruturas-de-cargos@matriz-grade-contexto',
  'page-estruturas-de-cargos@matriz-de-cargos-exportar',
  'page-estruturas-de-cargos@de-para-de-cargos',
  'page-estruturas-de-cargos@descricao-de-cargos',
  'page-estruturas-de-cargos@descricao-de-cargos-exportar',
  //** PAGE ESTRATEGIA DE REMUNERACAO**
  'page-estrategia-de-remuneracao@tabela-salarial-faixa-ampla',
  'page-estrategia-de-remuneracao@tabela-salarial-steps-fixos',
  'page-estrategia-de-remuneracao@custo-de-enquadramento',
  'page-estrategia-de-remuneracao@custo-de-enquadramento-exportar',
  'page-estrategia-de-remuneracao@dados-de-mercado-grade',
  'page-estrategia-de-remuneracao@dados-de-mercado-grade-exportar',
  'page-estrategia-de-remuneracao@dados-de-mercado-cargo',
  'page-estrategia-de-remuneracao@dados-de-mercado-cargo-exportar',
  'page-estrategia-de-remuneracao@analise-de-competitividade',
  'page-estrategia-de-remuneracao@analise-de-competitividade-exportar',
  'page-estrategia-de-remuneracao@alvos-de-incentivo',
  //** PAGE DHASBOARD**
  'page-dashboard-de-remuneracao@grandes-numeros',
  'page-dashboard-de-remuneracao@movimentacoes-salariais',
  'page-dashboard-de-remuneracao@dispersao-tabela',
  'page-dashboard-de-remuneracao@dispersao-mercado',
  'page-dashboard-de-remuneracao@analise-de-genero', //DIVERSIDADE
  //** PAGE MERITOCRACIA**
  'page-meritocracia',
  'page-meritocracia@exportar',
  'page-meritocracia@simulacoes',
  'page-meritocracia@simulacoes-recomendacao',
  'page-meritocracia@simulacoes-exportar',
  'page-meritocracia@parametrizacoes',
  'page-meritocracia@parametrizacoes-politicas',
  'page-meritocracia@parametrizacoes-criterios-de-analise',
  'page-meritocracia@parametrizacoes-modelo-de-simulacao',
  'page-meritocracia@parametrizacoes-orcamento',
  'page-meritocracia@parametrizacoes-distribuicao-de-orcamento',
  //** PAGE CENTRAL DE UPLOAD**
  'page-central-de-upload@template-de-tabela-salarial-download',
  'page-central-de-upload@template-de-tabela-salarial-upload',
  'page-central-de-upload@template-de-matching-de-cargos-download',
  'page-central-de-upload@template-de-matching-de-cargos-upload',
  'page-central-de-upload@template-de-matching-de-cargos-historico-upload',
  'page-central-de-upload@template-de-tabela-salarial-historico-upload',
  'page-central-de-upload@template-de-remuneracao-download',
  'page-central-de-upload@template-de-remuneracao-upload',
  'page-central-de-upload@template-de-remuneracao-historico-upload',
  'page-central-de-upload@template-de-historico-salarial-download',
  'page-central-de-upload@template-de-historico-salarial-upload',
  'page-central-de-upload@template-de-historico-salarial-historico-upload',
  'page-central-de-upload@upload',
  'page-central-de-upload@historico',
  'page-central-de-upload@historico-log',
  //** PAGE CONTROLE DE ACESSO**
  'page-controle-de-acesso@grupo',
  'page-controle-de-acesso@usuario',

  //** PERMISSAO VALORES GERAL **
  'valores@mercado-geral',
  'valores@benchmark',

  //** PERMISSAO MERCADOS **
  'mercado@percentil-p10',
  'mercado@percentil-p25',
  'mercado@percentil-p50',
  'mercado@percentil-p75',
  'mercado@percentil-p90',
  'mercado@linha-sb',
  'mercado@linha-td',
  'mercado@linha-rd',
  'mercado@linha-tda',
  'mercado@linha-rda',
  'mercado@linha-icp',
  'mercado@linha-ilp',

  'filter-areas', //GET /tenants/employees/areas , value = [area] (STRING)
  'filter-grades', // GET /tenants/positions/grades , value = [id] (STRING)
  'filter-tabelas', // GET /tenants/positions/grades/salaries/tables , value = [table_code] (STRING)
  'filter-empresas', // GET /tenants/employees/units , value = [company_unit] (STRING)
  'filter-diretorias', // GET /tenants/employees/directors , value = [director] (STRING)
] as const;

export type IPermissionNames = (typeof PERMISSIONS_NAMES)[number];
